<script setup lang="ts">
import type { MediaFragment, NewsThumbFragment } from '#graphql-operations'

interface CardPressProps {
  data: NewsThumbFragment
}

const props = defineProps<CardPressProps>()

const thumbMedia = computed(() => props.data.thumbMedia as MediaFragment[])
// const buttonLabel = computed(() => props.data.customLink?.label || props.data.customLink?.elementTitle)
</script>

<template>
  <article class="cardPress">
    <Anchor class="group group-buttonLink block" :to="data.url">
      <figure class="flex gap-2.5">
        <div class="rounded-2 bg-linen flex-none w-24 aspect-3/4 of-hidden">
          <CraftMedia
            v-for="media in thumbMedia"
            :key="media.id"
            class="motion-natural size-full object-cover group-hover-media-mouse:scale-110"
            :media
            :img-props="{ alt: data.title }"
          />
        </div>
        <figcaption class="flex flex-col justify-start">
          <Text as="h3" :text="data.title" class="typo-sans-1 mb-1em uppercase" />
          <Text :html="data.excerpt" class="typo-serif-1 line-clamp-2" />
          <div class="mt-auto">
            <ButtonLink :title="$t('read_more')" />
          </div>
        </figcaption>
      </figure>
    </Anchor>
  </article>
</template>
